const CONFIG = {
  URL: "https://siloamsummit-api.eventqiu.com/api",
  URL_MEDIA: "https://siloamsummit-api.eventqiu.com/media",
};

export default CONFIG;
